import { I18nProvider } from '@lingui/react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import logger from 'shared/services/logger'
import store from 'shared/store'

import NowGlobalBar from './'

export default ({ container, i18n }) => {
  if (container) {
    render(
      <Provider store={store}>
        <I18nProvider i18n={i18n}>
          <NowGlobalBar />
        </I18nProvider>
      </Provider>,
      container
    )
    logger.info('NowGlobalBar module loaded')
  }
}
